import styled from 'styled-components'

const Subheader = styled.p`
  font-size: ${({ isBig }) => (isBig ? '2em' : '1em')};
`

export default Subheader
